const LoadingSpinner = ({ text = "Загрузка данных..." }) => {
  return (
      <div className="text-center py-5">
        <span className="loader"></span>
        <p className="text-muted mt-3">Загрузка данных...</p>
      </div>
  );
};

export default LoadingSpinner;